import { Wand2, RotateCcw } from "lucide-react";
import { nativeHotspots } from "@/threedvista/bridge";

const norm = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]/g, "");

export function guessTarget(label, scenes, names) {
  const n = norm(label);
  if (!n) return "";
  const s = scenes.find((x) => norm(names[x.id]) === n || norm(x.label) === n);
  return s?.id || "";
}

export function nativeToOurs(nh, mediaId, scenes, names) {
  const goto = nh.nav ? guessTarget(nh.label, scenes, names) : "";
  return { id: crypto.randomUUID(), media_id: mediaId, yaw: nh.yaw, pitch: nh.pitch, title: nh.label, body: "", link_url: "", image_url: "", icon: nh.nav ? "door" : "info", style: "glass", color: "", icon_url: "", video_url: "", pdf_url: "", pdf_name: "", goto_media_id: goto, from_native: nh.id };
}

export function NativeHotspots({ t, up, tdv, cur, scenes, names, onPick }) {
  if (!tdv || !cur || cur.kind !== "Panorama") return null;
  const list = nativeHotspots(tdv, cur.index);
  if (!list.length) return null;
  const hidden = t.hidden_native || [];
  const open = list.filter((n) => !hidden.includes(n.id));
  const convert = (ns) => {
    const made = ns.map((n) => nativeToOurs(n, cur.id, scenes, names));
    up({ hotspots: [...t.hotspots, ...made], hidden_native: [...hidden, ...ns.map((n) => n.id)], own_hotspots: true });
    if (made.length === 1) onPick(made[0].id);
  };
  const restore = (nid) => up({ hidden_native: hidden.filter((x) => x !== nid), hotspots: t.hotspots.filter((h) => h.from_native !== nid) });
  return (
    <div className="rounded-2xl border bg-white p-4 space-y-2" data-testid="tdv-native-list">
      <div className="flex items-center gap-2">
        <p className="font-semibold text-sm flex-1">3DVista hotspots in this scene ({list.length})</p>
        {open.length > 0 && <button type="button" onClick={() => convert(open)} className="h-8 px-3 rounded-full bg-slate-900 text-white text-xs font-semibold inline-flex items-center gap-1.5" data-testid="tdv-native-convert-all"><Wand2 className="w-3.5 h-3.5" />Replace all with ours</button>}
      </div>
      <p className="text-[11px] text-slate-500">Replacing hides the 3DVista one and puts our hotspot in the same spot, so you can change its look and add text, photos, video or a PDF. For arrows that move to another room, we pick the room whose scene name matches; if none matches, choose the room under "When clicked".</p>
      {list.map((n, i) => {
        const done = hidden.includes(n.id);
        return (
          <div key={n.id} className="flex items-center gap-2 text-sm" data-testid={`tdv-native-${i}`}>
            <span className={`flex-1 truncate ${done ? "text-slate-400 line-through" : ""}`}>{n.label || `Hotspot ${i + 1}`}{n.nav ? " · moves to a room" : ""}</span>
            {done ? <button type="button" onClick={() => restore(n.id)} className="text-xs font-semibold text-slate-600 inline-flex items-center gap-1" data-testid={`tdv-native-restore-${i}`}><RotateCcw className="w-3.5 h-3.5" />Undo</button>
              : <button type="button" onClick={() => convert([n])} className="text-xs font-semibold text-bp" data-testid={`tdv-native-convert-${i}`}>Replace with ours</button>}
          </div>
        );
      })}
    </div>
  );
}
